import firebase from "firebase/app";

import { useTranslation } from "react-i18next";

import updateOrganization from "astrid-firestore/src/api/organizations/updateOrganization";

export default function useDistributionPresetDropdownOptions({ publisher }) {
	const { t } = useTranslation();

	return (preset) => [
		{
			text: t("remove", "Remove"),
			action: () => {
				return updateOrganization(firebase, publisher.ref, {
					[`distribution.presets.${preset.id}`]: firebase.firestore.FieldValue.delete(),
				});
			},
		},
		{
			text: preset.disabled ? t("enable", "Enable") : t("disable", "Disable"),
			action: () => {
				return updateOrganization(firebase, publisher.ref, {
					[`distribution.presets.${preset.id}`]: { ...preset, disabled: !preset.disabled },
				});
			},
		},
	];
}
